module.exports = __webpack_public_path__ + "0d9153ac06e5210241f900f7827ce94c.svg";